<template>
	<div>
		<div class="submissions-list table-responsive b-0" ref="ordersList">
			<table
				ref="ordersListTable"
				class="table table-primary table-striped table-hover table--small submissions-list-table"
			>
				<thead>
					<tr>
						<!-- <th>
							<label class="input-checkbox-container">
								<input type="checkbox" class="input-checkbox" @input="selectAll" />
								<span></span>
							</label>
						</th> -->
						<th
							v-for="(header, index) in tHeaders"
							:key="index"
							class="th-sort hidden-sm"
						>
							<span>
								{{ header.label }}
							</span>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(data, i) in privateOrders" :key="i">
						<!-- <td>
							<label class="input-checkbox-container">
								<input
									type="checkbox"
									class="input-checkbox"
									:value="data.order_id"
									v-model="selected"
									@input="onSelectedData(data.order_id)"
								/>
								<span></span>
							</label>
						</td> -->
						<td
							v-for="(value, key) in data"
							:key="key"
							class="p-4 border-b border-gray-200"
						>
							<CustomerColumn
								v-if="key === 'customer_data'"
								:data="data"
								@show-detail-orders="showDetailOrders"
							/>
							<ProductColumn v-else-if="key === 'product_data'" :data="data" />
							<OrderIdColumn
								v-else-if="key === 'order_id'"
								:data="data"
								@show-detail-orders="showDetailOrders"
							/>
							<StatusColumn
								v-else-if="
									key === 'status' ||
									key === 'payment_status' ||
									key === 'payment_info' ||
									key === 'order_type' ||
									key === 'payment_type'
								"
								:field-key="key"
								:data="data"
							/>
							<ReceiptNumberColumn v-else-if="key === 'shipping'" :data="data" />
							<DateColumn v-else-if="key === 'processing_at' || key === 'created_at'" :data="data" :fieldKey="key" />
							<PriceColumn
								v-else-if="
									key === 'total_price' ||
									key === 'base_product_price' ||
									key === 'other_cost' ||
									key === 'shipping_cost' ||
									key === 'product_price' ||
									key === 'total_product_price' ||
									key === 'base_product_price' ||
									key === 'total_base_product_price'
								"
								:data="data"
								:field-key="key"
							/>
							<ActionColumn
								v-else-if="key === 'action'"
								:data="data"
								@on-action="onAction"
							/>
							<div
								v-else
								class="text-gray-700 d-flex items-center"
								style="white-space: nowrap"
							>
								<span>
									{{ data[key] || '-' }}
								</span>
							</div>
						</td>
					</tr>
				</tbody>
			</table>

			<div
				class="list-empty table-empty text-center"
				v-if="privateOrders.length === 0 && !isLoading"
			>
				<i class="material-icons mr-2">error_outline</i>
				<span>No Orders Found</span>
			</div>

			<!-- Loader -->
			<div class="my-3 p-3 text-center" v-if="isLoading">
				<div class="is-loading dark large"></div>
			</div>
			<OrderDetailModal
				v-if="orderDetailVisible"
				:data="orderDetail"
				@close="orderDetailVisible = false"
			/>
			<EditOrderModal
				v-if="editOrderModalVisible"
				:data="orderDetail"
				:is-submit-load="isSubmitLoading"
				@close="editOrderModalVisible = false"
				@submit="updateStatus"
			/>
			<ProccessOrderModal
				v-if="proccessOrderVisible"
				:data="orderDetail"
				:type="proccessOrderType"
				:is-submit-loading="isSubmitLoading"
				@close="proccessOrderVisible = false"
				@submit="processOrder"
			/>
			<UpdateStatusModal
				v-if="isUpdateStatusModalVisible"
				:data="orderDetail"
				:type="modalType"
				:is-loading="isSubmitLoading"
				@close="isUpdateStatusModalVisible = false"
				@update="updateStatus"
				@change-rceipt-number="updateReceiptNumber"
			/>
			<div class="table-vertical-scroll hidden-sm" ref="ordersListVerticalScroll">
				<div
					class="table-vertical-scroll-content"
					ref="ordersListVerticalScrollContent"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { duplicateVar } from '@/lib/helper';
import OrderDetailModal from '@/components/private-orders/modal/OrderDetails.vue';
import EditOrderModal from '@/components/private-orders/modal/edit-order/index.vue';
import ActionColumn from '@/components/private-orders/column/Actions.vue';
import CustomerColumn from '@/components/private-orders/column/Customer.vue';
import ProductColumn from '@/components/private-orders/column/Product.vue';
import OrderIdColumn from '@/components/private-orders/column/OrderIdColumn.vue';
import StatusColumn from '@/components/private-orders/column/Status.vue';
import ProccessOrderModal from '@/components/private-orders/modal/proccess-order/index.vue';
import UpdateStatusModal from '@/components/private-orders/modal/UpdateStatus.vue';
import ReceiptNumberColumn from '@/components/private-orders/column/ReceiptNumber.vue';
import PriceColumn from './column/PriceColumn.vue';
import DateColumn from '@/components/private-orders/column/DateColumn.vue';
import { updateDataOrder, processDataOrder, adminUpdateOrder } from '@/api/private-order';

export default {
	name: 'PrivateOrderTable',
	props: {
		items: {
			type: Array,
			default: () => [],
		},
		isLoading: {
			type: Boolean,
			default: () => false,
		},
		type: {
			type: String,
			default: '',
		},
	},
	components: {
		OrderDetailModal,
		ActionColumn,
		CustomerColumn,
		ProductColumn,
		OrderIdColumn,
		EditOrderModal,
		StatusColumn,
		ProccessOrderModal,
		UpdateStatusModal,
		ReceiptNumberColumn,
		PriceColumn,
		DateColumn,
	},
	data() {
		return {
			tHeaders: [],
			selected: [],
			orderDetailVisible: false,
			editOrderModalVisible: false,
			proccessOrderVisible: false,
			isUpdateStatusModalVisible: false,
			proccessOrderType: '',
			orderDetail: null,
			modalType: '',
			isSubmitLoading: false,
		};
	},
	computed: {
		...mapGetters({
			privateOrders: 'monitoringPrivateOrder/privateOrders',
			isAdmin: 'isAdmin',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
			selectedData: 'monitoringPrivateOrder/selectedData',
		}),
	},
	created() {
		this.setVerticalScroll();
		this.init();
		document.addEventListener('scroll', this.onDocumentScroll, true);
		window.addEventListener('resize', this.checkListTable, true);
	},
	destroyed() {
		document.removeEventListener('scroll', this.onDocumentScroll, true);
		window.removeEventListener('resize', this.checkListTable, true);
	},
	updated() {
		this.$nextTick(() => {
			this.setVerticalScroll();
			this.checkListTable();
		});
	},
	methods: {
		...mapActions({
			updateDataPrivateOrder: 'monitoringPrivateOrder/updateData',
			setDetailOrder: 'monitoringPrivateOrder/setDetailOrder',
			setSelectedData: 'monitoringPrivateOrder/setSelectedData',
			addToSelected: 'monitoringPrivateOrder/addToSelected',
			removeFromSelected: 'monitoringPrivateOrder/removeFromSelected',
		}),
		duplicateVar,
		init() {
			if (this.isSupplier || this.type === 'supplier') {
				this.tHeaders = [
					{ key: 'order_id', label: 'Order Id' },
					{ key: 'customer', label: 'Customer' },
					{ key: 'product', label: 'Product' },
					{ key: 'sku', label: 'Product Sku' },
					{ key: 'quantity', label: 'Quantity' },
					{ key: 'base_product_price', label: 'Product Price HPP' },
					{ key: 'total_base_product_price', label: 'Total Product Price HPP' },
					{ key: 'shipping_cost', label: 'Shipping Cost' },
					{ key: 'other_cost', label: 'Other Cost' },
					{ key: 'total_price', label: 'Total Price' },
					{ key: 'city', label: 'City' },
					{ key: 'status', label: 'Status' },
					{ key: 'order_type', label: 'Order Type' },
					{ key: 'payment_status', label: 'Payment Status' },
					{ key: 'payment_info', label: 'Payment Info' },
					{ key: 'payment_type', label: 'Payment Type' },
					{ key: 'receipt_number', label: 'Receipt Number' },
					{ key: 'created_at', label: 'Created At' },
					{ key: 'processing_at', label: 'Processing At' },
					{ key: 'actions', label: 'Actions' },
				];
			}

			if (this.isDropshipper || this.type === 'dropshipper') {
				this.tHeaders = [
					{ key: 'order_id', label: 'Order Id' },
					{ key: 'customer', label: 'Customer' },
					{ key: 'product', label: 'Product' },
					{ key: 'sku', label: 'Product Sku' },
					{ key: 'quantity', label: 'Quantity' },
					{ key: 'product_price', label: 'Product Price' },
					{ key: 'total_price', label: 'Total Product Price' },
					{ key: 'shipping_cost', label: 'Shipping Cost' },
					{ key: 'other_cost', label: 'Other Cost' },
					{ key: 'total_mount_price', label: 'Total Price' },
					{ key: 'city', label: 'City' },
					{ key: 'status', label: 'Status' },
					{ key: 'order_type', label: 'Order Type' },
					{ key: 'payment_status', label: 'Payment Status' },
					{ key: 'payment_info', label: 'Payment Info' },
					{ key: 'payment_type', label: 'Payment Type' },
					{ key: 'receipt_number', label: 'Receipt Number' },
					{ key: 'created_at', label: 'Created At' },
					{ key: 'processing_at', label: 'Processing At' },
					{ key: 'actions', label: 'Actions' },
				];
			}

			if (this.type === 'admin') {
				this.tHeaders = [
					{ key: 'order_id', label: 'Order Id' },
					{ key: 'customer', label: 'Customer' },
					{ key: 'product', label: 'Product' },
					{ key: 'sku', label: 'Product Sku' },
					{ key: 'quantity', label: 'Quantity' },
					{ key: 'base_product_price', label: 'Product Price HPP' },
					{ key: 'total_base_product_price', label: 'Total Product Price HPP' },
					{ key: 'product_price', label: 'Product Price' },
					{ key: 'total_price_product', label: 'Total Product Price' },
					{ key: 'other_cost', label: 'Other Cost' },
					{ key: 'shipping_cost', label: 'Shipping Cost' },
					{ key: 'total_price', label: 'Total Price' },
					{ key: 'city', label: 'City' },
					{ key: 'status', label: 'Status' },
					{ key: 'order_type', label: 'Order Type' },
					{ key: 'payment_status', label: 'Payment Status' },
					{ key: 'payment_info', label: 'Payment Info' },
					{ key: 'payment_type', label: 'Payment Type' },
					{ key: 'receipt_number', label: 'Receipt Number' },
					{ key: 'created_at', label: 'Created At' },
					{ key: 'processing_at', label: 'Processing At' },
					{ key: 'actions', label: 'Actions' },
				];
			}
		},
		onSelectedData(orderId) {
			const isExistIndex = this.selectedData.findIndex(id => id === orderId);
			if (isExistIndex !== -1) {
				this.removeFromSelected(orderId);
			} else {
				this.addToSelected(orderId);
			}

			this.selected = this.selectedData;
		},
		selectAll() {
			this.selected = this.selected.length !== this.privateOrders.length
				? this.privateOrders.map(item => item.order_id)
				: [];

			this.setSelectedData(this.selected); // Mengganti seluruh array dengan options baru
		},
		showDetailOrders(product) {
			this.orderDetailVisible = !this.orderDetailVisible;
			this.orderDetail = product;
		},
		onAction(key, data) {
			if (key === 'edit_order') {
				this.editOrderModalVisible = true;
				this.orderDetail = data;
			} else if (key === 'process_orders') {
				this.proccessOrderVisible = true;
				this.proccessOrderType = data.order_type;
				this.orderDetail = data;
			} else if (key === 'mark_as_received' || key === 'mark_as_delivery') {
				this.isUpdateStatusModalVisible = true;
				this.orderDetail = data;
				this.modalType = 'confirm';
			} else if (key === 'input_receipt_number') {
				this.isUpdateStatusModalVisible = true;
				this.orderDetail = data;
				this.modalType = 'input_receipt_number';
			} else if (key === 'update_status') {
				this.isUpdateStatusModalVisible = true;
				this.orderDetail = data;
				this.modalType = key;
			}
		},
		updateStatus(value, type) {
			this.isSubmitLoading = true;
			const params = {};

			if (type === 'edit_order') {
				params.customer_data = {
					name: value?.[0]?.form?.name ?? null,
					phone: value?.[0]?.form?.phone ?? null,
					email: value?.[0]?.form?.email ?? null,
					address: value?.[0]?.form?.address ?? null,
					province_id: value?.[0]?.form?.shipping?.province?.value?.key ?? null,
					province_name: value?.[0]?.form?.shipping?.province?.value?.label ?? null,
					city_id: value?.[0]?.form?.shipping?.city?.value?.key ?? null,
					city_name: value?.[0]?.form?.shipping?.city?.value?.label ?? null,
					subdistrict_name: value?.[0]?.form?.shipping?.subdistrict?.value?.label ?? null,
					subdistrict_id: value?.[0]?.form?.shipping?.subdistrict?.value?.key ?? null,
					zip: value?.[0]?.form?.shipping.zip ?? null,
				};

				params.order_data = {
					quantity: value?.[1]?.form?.quantity,
					notes: value?.[1]?.form?.notes,
					payment_method: value?.[1]?.form?.payment_method?.value?.key,
				};

				params.type = 'edit_order';
			}

			if (type === 'update_status') {
				params.status = value?.key;
			}

			if (type === 'input_receipt_number') {
				params.receipt_number = value.receiptNumber;
				params.cancelled_receipt_number = value.cancelledReceiptNumber;
				params.type = this.modalType;
			}

			if (type === 'confirm') {
				params.status = value?.key;
			}

			const id = this.orderDetail?.action;
			const callback = (res) => {
				const payload = {
					id,
					role_type: this.type,
					...res?.data?.data,
				};

				if (payload && res?.data?.message === 'success') {
					this.updateDataPrivateOrder(payload);
					this.$notify({
						group: 'app',
						title: 'Wholesale Order',
						text: 'Updated Status Successfully',
						type: 'success',
					});
				} else {
					const message = res?.data?.message;

					this.$notify({
						group: 'app',
						title: 'Wholesale Order',
						text: message,
						type: 'error',
					});
				}

				this.isUpdateStatusModalVisible = false;
				this.editOrderModalVisible = false;
				this.$emit('trigger-summary');
				this.isSubmitLoading = false;
			};

			const err = (e) => {
				console.log(e);
				this.$notify({
					group: 'app',
					title: 'Wholesale Order',
					text: 'Updated Status Successfully',
					type: 'success',
				});
			};

			if (this.type === 'admin') {
				adminUpdateOrder(id, params, callback, err);
			} else {
				updateDataOrder(id, params, callback, err);
			}
		},
		updateReceiptNumber(receiptNumber, cancelledReceiptNumber) {
			const params = {
				receiptNumber,
				cancelledReceiptNumber,
			};

			this.updateStatus(params, 'input_receipt_number');
		},
		processOrder(dataParams) {
			this.isSubmitLoading = true;
			const id = this.orderDetail?.action;
			const params = {
				type: dataParams.type,
				shipping_cost: dataParams.shipping_cost,
				other_cost: dataParams?.other_cost,
				total_payment: dataParams?.total_payment ?? 0,
				due_date: dataParams?.due_date ?? null,
				payment_method: dataParams?.payment_method ?? null,
			};

			if (dataParams.type === 'private_order_dp') {
				params.total_payment_settlement = dataParams?.dp.total_payment_settlement;
				params.due_date_settlement = dataParams?.dp.due_date_settlement;
				params.total_payment = dataParams?.dp.total_payment;
				params.due_date = dataParams?.dp.due_date;
			}

			const callback = (res) => {
				if (res.data.error_code === 0) {
					const payload = {
						id,
						...res?.data?.data,
					};
					this.updateDataPrivateOrder(payload);

					this.$notify({
						group: 'app',
						title: 'Wholesale Order',
						text: 'Process Order Successfully',
						type: 'succes',
					});
				} else {
					this.$notify({
						group: 'app',
						title: 'Wholesale Order',
						text: res.data.message,
						type: 'error',
					});
				}

				this.isSubmitLoading = false;
				this.proccessOrderVisible = false;
			};
			const err = (e) => {
				console.log(e.response.data.message);
				this.$notify({
					group: 'app',
					title: 'Wholesale Order',
					text: e.response.data.message,
					type: 'error',
				});
				this.isSubmitLoading = false;
				this.proccessOrderVisible = false;
			};

			processDataOrder(id, params, callback, err);
		},
		onUpdateDataOrder(forms) {
			const id = this.orderDetail.action;
			const params = {
				customer_data: {
					name: forms?.[0]?.form?.name ?? null,
					phone: forms?.[0]?.form?.phone ?? null,
					email: forms?.[0]?.form?.email ?? null,
					address: forms?.[0]?.form?.address ?? null,
					province_id: forms?.[0]?.form?.shipping?.province?.value?.key ?? null,
					province_name: forms?.[0]?.form?.shipping?.province?.value?.label ?? null,
					city_id: forms?.[0]?.form?.shipping?.city?.value?.key ?? null,
					city_name: forms?.[0]?.form?.shipping?.city?.value?.label ?? null,
					subdistrict_name: forms?.[0]?.form?.shipping?.subdistrict?.value?.label ?? null,
					subdistrict_id: forms?.[0]?.form?.shipping?.subdistrict?.value?.key ?? null,
					zip: forms?.[0]?.form?.shipping.zip ?? null,
				},
				order_data: {
					quantity: forms?.[1]?.form?.quantity,
					notes: forms?.[1]?.form?.notes,
					payment_method: forms?.[1]?.form?.payment_method?.value?.key,
				},
			};

			const callback = () => {
				//
			};
			const err = e => console.log(e);

			updateDataOrder(id, params, callback, err);
		},
		updateDataOrder(forms) {
			console.log('forms -> ', forms);
		},
		onDocumentScroll(event) {
			if (event.target === document) {
				this.checkListTable();
			} else if (event.target === this.$refs.ordersList) {
				this.$refs.ordersListVerticalScroll.scrollLeft = this.$refs.ordersList.scrollLeft;
			} else if (event.target === this.$refs.ordersListVerticalScroll) {
				this.$refs.ordersList.scrollLeft = this.$refs.ordersListVerticalScroll.scrollLeft;
			}
		},
		checkListTable() {
			if (this.$refs.ordersList) {
				this.$refs.ordersListVerticalScroll.style.display = 'block';
			}
		},
		setVerticalScroll() {
			if (this.$refs.ordersList) {
				const listWidth = this.$refs.ordersList.offsetWidth;
				const tableWidth = this.$refs.ordersListTable.offsetWidth;
				this.$refs.ordersListVerticalScroll.style.width = `${listWidth}px`;
				this.$refs.ordersListVerticalScrollContent.style.width = `${tableWidth}px`;
			}
		},
	},
};
</script>

<style lang="scss">
.private-order-table {
	tbody {
		tr {
			&:hover {
				.btn-orderid {
					opacity: 1;
				}
			}
		}
	}
}
</style>
